import { makeAutoObservable, runInAction } from "mobx";
import SubscriptionPlansService from "../../../services/api/subscription-plans-service";
import { rootContainer, TYPE } from "../../../services/container/root";
import { PlanStore } from "../../subscription-plans/stores/subscription-plans-store";


class OnBoardingPlansStore {
    private _isLoading: boolean = false;
    private _list: PlanStore[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get isLoading(): boolean { return this._isLoading; }

    private get subscriptionPlansService(): SubscriptionPlansService {
        return rootContainer.get<SubscriptionPlansService>(TYPE.SubscriptionPlansService);
    }

    public getPlanById(planId: number): PlanStore | undefined {
        return this._list.find(plan => plan.id === planId);
    }

    public get list(): PlanStore[] {
        return this._list.filter(p => !p.isDefaultCoveragePlan);
    }

    public get onboardingCoveragePlan(): PlanStore|undefined { 
        return this._list.find(plan => plan.isDefaultCoveragePlan); 
    }


    public async load() {
        try {
            this._isLoading = true;
            const plans = await this.subscriptionPlansService.getOnBoardingPlans();

            runInAction(() => {
                this._isLoading = false;
                this._list = plans.map(model => new PlanStore(model));
                this._list.forEach((planStore) => planStore.setShouldRenderLongDescription(true));
            })
        }
        catch (e) {
            runInAction(() => {
                this._isLoading = false;
            })
        }
    }

}

export default new OnBoardingPlansStore();